const MATERIALS = ['msand', 'csand', 'rsand', '12mm', '20mm'];

export function correctionFactor(absorption, moisture) {
  return Number((parseFloat(absorption) || 0) - (parseFloat(moisture) || 0)).toFixed(2);
}

export function applyCorrectionFactors(fields) {
  const next = { ...fields };
  MATERIALS.forEach((material) => {
    next[`correction_factor_${material}`] = correctionFactor(
      next[`absorption_${material}`],
      next[`moisture_${material}`],
    );
  });
  return next;
}

export function mapMoistureApiToInputs(response) {
  const fields = {
    id: response.id,
    plant_id: response.plant_id,
    plant_name: response.plant_name,
    mc_no: response.mc_no || '',
    mc_date: response.mc_date || '',
    mc_time: (response.mc_time || '').slice(0, 5),
    is_active: response.is_active !== false,
    delivery_challan_count: Number(response.delivery_challan_count ?? 0),
    can_update_in_place: response.can_update_in_place,
    moisture_msand: response.moisture?.msand ?? 0,
    moisture_csand: response.moisture?.csand ?? 0,
    moisture_rsand: response.moisture?.rsand ?? 0,
    moisture_12mm: response.moisture?.['12mm'] ?? 0,
    moisture_20mm: response.moisture?.['20mm'] ?? 0,
    absorption_msand: response.absorption?.msand ?? 0,
    absorption_csand: response.absorption?.csand ?? 0,
    absorption_rsand: response.absorption?.rsand ?? 0,
    absorption_12mm: response.absorption?.['12mm'] ?? 0,
    absorption_20mm: response.absorption?.['20mm'] ?? 0,
  };
  return applyCorrectionFactors(fields);
}

export const MOISTURE_MATERIALS = [
  ['msand', 'MSAND'],
  ['csand', 'CSAND'],
  ['rsand', 'RSAND'],
  ['12mm', '12 MM'],
  ['20mm', '20 MM'],
];
